import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { User } from './user.interface';
import { UserService } from './user.service';
const service = new UserService();

export interface UserState {
   user?: User;
   users: Array<User>;
   canEdit: boolean;
}

const UserStore: Module<UserState, StoreState> = {
   namespaced: true,
   state: {
      users: [],
      canEdit: false,
   },
   getters: {},
   mutations: {
      SET_USER(state, user: User) {
         state.user = user;
      },
      SET_USER_PARTNER(state, partner: User) {
         state.user!.partner = partner;
      },
      SET_USERS(state, users: Array<User>) {
         state.users = users;
      },
      SET_CAN_EDIT(state, canEdit: boolean) {
         state.canEdit = canEdit;
      },
   },
   actions: {
      async getUser({ commit }, userId: string) {
         const user = await service.getUser(userId);
         commit('SET_USER', user);
         return user;
      },
      async getUsers({ commit }) {
         const users = await service.getUsers(this.state.user!.user!.firebase_id!);

         commit('SET_USERS', users);
         return users;
      },
      async searchUser({ commit }, search: string) {
         const users = await service.searchUser(search);
         commit('SET_USERS', users);
         return users;
      },
      async postUser({ commit }, user: User) {
         const response = await service.postUser(user);
         commit('SET_USER', response);
         return response;
      },
      async putUser({ commit }, user: User) {
         await service.putUser(user);
         const response = (await service.getUser(user.firebase_id!)) as User;

         commit('SET_USER', response);
         return response;
      },
      async putPartner(state, user: User) {
         await service.putUser(user);
      },
   },
};

export default UserStore;
